let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9DbQT")).then(() => parcelRequire('5alWC'));